export default __webpack_public_path__ + "static/media/380.7784e7ce.jpg";